module.exports = __webpack_public_path__ + "img/icon_box_1_4.9b2fd9f7.png";